export default __webpack_public_path__ + "media/a03c1f47e119c1c65f05be06b448a1808c9e6b2a09bb9199b42b777a25bc1c6f.svg";